import React from 'react'

import { Search as SearchIcon } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { useSearchOverlayContext } from '../../../containers/SearchOverlayContext'
import { NavTab } from '../../../types/graphql'

import { SearchContainer, SearchText } from './SearchBar.styles'

const Search = () => {
  const { languageGroup } = useLocalization()
  const {
    search: { inputPlaceholder },
  } = useTranslation()
  if (languageGroup !== 'en') return null

  return (
    <SearchContainer>
      <SearchIcon />
      <SearchText>{inputPlaceholder}</SearchText>
    </SearchContainer>
  )
}

export function useSearchTab(): NavTab {
  const { shouldDisplaySearchOverlay, toggleSearchOverlay } = useSearchOverlayContext()
  const {
    search: { searchButtonAriaLabelClose, searchButtonAriaLabelOpen },
  } = useTranslation()

  const searchTab: NavTab = {
    __typename: 'NavTab',
    ariaLabel: shouldDisplaySearchOverlay ? searchButtonAriaLabelClose : searchButtonAriaLabelOpen,
    href: null,
    id: 'search',
    onClickish: () => {
      if (shouldDisplaySearchOverlay) {
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
      }
      toggleSearchOverlay()
    },
    render: () => !shouldDisplaySearchOverlay && <Search />,
    sections: [],
    text: '',
    textColor: null,
    wrapperElement: 'button',
    alternateModelVariant: null,
  }

  return searchTab
}
